import JsTypeInspector from "../../serviceLayer/validators/JsTypeInspector";
import ProcessStatus from "../../utils/enumerations/ProcessStatus";
import FormInputStatus from "../../utils/enumerations/FormInputStatus";
import ValidationService from "../../serviceLayer/validators/ValidationService";
import TargetApiUrlAndPath from "../../utils/webApi/TargetApiUrlAndPath";
import HttpRequestService from "../../serviceLayer/httpProtocol/HttpRequestService";
import SessionDataStorer from "../../dataAccessLayer/session/SessionDataStorer";
import SessionKey from "../../dataAccessLayer/session/SessionKey";
import LocalStorageDataStorer from "../../dataAccessLayer/localStorage/LocalStorageDataStorer";
import LocalStorageKey from "../../dataAccessLayer/localStorage/LocalStorageKey";
import HtmlTagName from "../../utils/stringLiterals/HtmlTagName";
import HttpStatusCode from "../../utils/httpProtocol/HttpStatusCode";


const grantAccess = function(loginPageCallback){
    const form = document.getElementById("loginCustomerForm1");
    if(form != null){
        const email = form[0].value;       
        const password = form[1].value;
        let errorsReport = processGrantAccessInputValidation(email, password);
        const reportIsNullOrEmpty = JsTypeInspector.objectIsNullOrEmpty(errorsReport);       
        if(!reportIsNullOrEmpty){
            errorsReport.status = ProcessStatus.FailedWithErrors;

            return errorsReport;
        }

        processHttpRequest(email, password, loginPageCallback);
    }
}

const exitApplication = function(logoutCallback){ 
    const url = HttpRequestService.getUrl(TargetApiUrlAndPath.API_AUTH_LOGOUT_PATH );
    const payload = {};
    HttpRequestService.POSTMethod(url, payload, (httpResponse)=>{
        processExitApplicationHttpResponseCallback(httpResponse);
        logoutCallback(httpResponse);
    });
}
//#region Private Functions BEGIN
function processGrantAccessInputValidation(email, password){
    const formInputStatusRequired = FormInputStatus[FormInputStatus.Required];
    const emailErrorsReport = ValidationService.validateInput(HtmlTagName.EMAIL, formInputStatusRequired , email);
    const passwordErrorsReport = ValidationService.validateInput(HtmlTagName.PASSWORD, formInputStatusRequired, password);
    let completeErrorsReport = Object.assign({}, emailErrorsReport, passwordErrorsReport);

    return completeErrorsReport;
}

function processHttpRequest(email, password, loginPageCallback){
    const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    //console.log(userTimeZone);
    const url = HttpRequestService.getUrl( TargetApiUrlAndPath.API_AUTH_LOGIN_PATH );
    const payload = { email: email, password: password, timeZone: userTimeZone }

    HttpRequestService.POSTMethod(url, payload, (httpResponse)=>{
        processGrantAccessHttpResponseCallback(httpResponse);
        loginPageCallback(httpResponse);
    });
}

function processGrantAccessHttpResponseCallback(httpResponse){
    if(httpResponse.code === HttpStatusCode._200ok.code ){
        let properties = { path: '/', sameSite: 'Lax' };
        SessionDataStorer.insertSessionInCookieStorage(SessionKey.sessionID, httpResponse.payload.sessionToken, properties );
        LocalStorageDataStorer.setItemInLocalStorage(LocalStorageKey.jwtUserToken, httpResponse.payload.jwtToken );
    }
}

function processExitApplicationHttpResponseCallback(httpResponse){
    //console.log("processExitApplicationHttpResponseCallback-httpResponse" , httpResponse);
    const cookiePath = '/';
    SessionDataStorer.deleteSessionFromCookieStorageByNameAndPath(SessionKey.sessionID , cookiePath);
    SessionDataStorer.deleteSessionFromCookieStorageByNameAndPath(SessionKey.x_csrf_token_client , cookiePath);
    SessionDataStorer.deleteSessionFromCookieStorageByNameAndPath(SessionKey.x_csrf_token_key_ , cookiePath);
    
    
    LocalStorageDataStorer.removeItemFromLocalStorage(LocalStorageKey.jwtUserToken);
    LocalStorageDataStorer.removeItemFromLocalStorage(LocalStorageKey.QuestionnaireUserResponses);
    LocalStorageDataStorer.removeItemFromLocalStorage(LocalStorageKey.currentQuestionnairePage);
    LocalStorageDataStorer.removeItemFromLocalStorage(LocalStorageKey.originalRandomizedQuestionnaire);
    LocalStorageDataStorer.removeItemFromLocalStorage(LocalStorageKey.questionnaireSubmitted);
    LocalStorageDataStorer.removeItemFromLocalStorage(LocalStorageKey.totalQuestionnairePages);
    LocalStorageDataStorer.removeItemFromLocalStorage(LocalStorageKey.allCharacterTypeColors);
    LocalStorageDataStorer.removeItemFromLocalStorage(LocalStorageKey.allCharacterTypeNames);
    LocalStorageDataStorer.removeItemFromLocalStorage(LocalStorageKey.allCharacterTypesDataPoints);
    LocalStorageDataStorer.removeItemFromLocalStorage(LocalStorageKey.allQuestionnaireResponseDataPoints);
    LocalStorageDataStorer.removeItemFromLocalStorage(LocalStorageKey.allScatterChartDataPoints);
    LocalStorageDataStorer.removeItemFromLocalStorage(LocalStorageKey.mostTwoDominantCharacterTypes);
    LocalStorageDataStorer.removeItemFromLocalStorage(LocalStorageKey.apiResourcesAndActions);
    LocalStorageDataStorer.removeItemFromLocalStorage(LocalStorageKey.customerResourcesAndActions);
    LocalStorageDataStorer.removeItemFromLocalStorage(LocalStorageKey.frontEndResourcesAndActions);
    LocalStorageDataStorer.removeItemFromLocalStorage(LocalStorageKey.standardSessionDuration);

}
//#region Private Functions END


const SessionManager = Object.freeze({
    grantAccess : grantAccess,
    exitApplication : exitApplication
});

export default SessionManager;